import {
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js/auto";
import React, { useEffect, useRef, useState } from "react";
import { Bar } from "react-chartjs-2";
import { connect } from "react-redux";
import {
  getWarehouseOccupancyCardData,
  getWarehouseOccupancyReportHome,
  getWarehouseZonesReportHome,
} from "../../store";

import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "../../index.css";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import Cookies from "universal-cookie";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const cookies = new Cookies();

const WarehouseOccupancyHomePageCard = ({
  getWarehouseOccupancyReportHome,
  getWarehouseOccupancyReportHomeReducer,
  getWarehouseZonesReportHome,
  getWarehouseOccupancyDataReducer,
  getWarehouseOccupancyCardData,
  getWarehouseZonesHomeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;
  let jwtToken = loginDetails?.jwt;

  const [warehouseOccupancyTitle, setWarehouseOccupancyTitle] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getWarehouseOccupancyCardData(jwtToken);
  }, [jwtToken]);

  useEffect(() => {
    getWarehouseOccupancyReportHome(jwtToken);
  }, [jwtToken]);

  const [warehouseChartData, setWarehouseChartGroupData] = useState([]);

  const [warehouseOccupancyData, setWarehouseOccupancyData] = useState([]);

  useEffect(() => {
    let data = getWarehouseOccupancyReportHomeReducer?.warehouses?.data
      ?.occupancy
      ? getWarehouseOccupancyReportHomeReducer.warehouses.data.occupancy
      : [];
    setWarehouseOccupancyData(data);
    setWarehouseOccupancyTitle(
      getWarehouseOccupancyReportHomeReducer?.warehouses?.data?.reportTitle,
    );
  }, [getWarehouseOccupancyReportHomeReducer]);

  const chartDataReport = {
    labels: warehouseOccupancyData?.map((item) => item.type) || [],
    datasets: {
      label: "Filled",
      data: warehouseOccupancyData?.map((item) => item.occupaidLocations) || [],
    },
  };

  useEffect(() => {
    if (
      Array.isArray(getWarehouseOccupancyDataReducer?.occupancy?.data) &&
      getWarehouseOccupancyDataReducer.occupancy.data.length > 0
    ) {
      setWarehouseChartGroupData(
        getWarehouseOccupancyDataReducer.occupancy.data,
      );
    }
  }, [getWarehouseOccupancyDataReducer]);

  const warehouseGroupData = warehouseChartData;

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const styles = {
    iconButton: {
      marginLeft: "10px",
      padding: "12px",
      borderRadius: "50%",
      backgroundColor: isHovered ? "#0056b3" : "#007bff",
      color: "white",
      boxShadow: isFocused
        ? "0 0 0 4px rgba(38, 143, 255, 0.5)"
        : "0 4px 12px rgba(0, 123, 255, 0.3)",
      transition: "all 0.3s ease-in-out",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isHovered ? "scale(1.1)" : "scale(1)",
    },
  };

  const createChartData = (data) => ({
    labels: data.map((item) => item.label),
    warehouseIds: data.map((item) => item.id),

    datasets: [
      {
        label: "Filled",
        data: data.map((item) => item.filled),

        backgroundColor: data.map((item) => item.colors?.filled?.bg || "#ddd"),
        borderColor: data.map((item) => item.colors?.filled?.border || "#aaa"),

        borderWidth: 1,
      },
      {
        label: "Empty",
        data: data.map((item) => item.empty),
        backgroundColor: data.map((item) => item.colors?.empty?.bg || "#eee"),
        borderColor: data.map((item) => item.colors?.empty?.border || "#bbb"),

        borderWidth: 1,
      },
    ],
  });

  const [chartDataList, setChartDataList] = useState([]);
  const [warehouseOccuZonesData, setWarehouseOccuZonesData] = useState({});
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
  const chartRefs = useRef({});

  useEffect(() => {
    if (Array.isArray(warehouseGroupData) && warehouseGroupData.length > 0) {
      const preparedList = warehouseGroupData.map((group) => {
        const chartData = createChartData(group.warehouses);
        return {
          type: group.type,
          title: group.title,
          initialData: chartData,
          currentData: chartData,
          isZoneView: false,
        };
      });
      setChartDataList(preparedList);
    }
  }, [warehouseGroupData]);

  useEffect(() => {
    chartDataList.forEach((card) => {
      if (!chartRefs.current[card.type]) {
        chartRefs.current[card.type] = React.createRef();
      }
    });
  }, [chartDataList]);

  useEffect(() => {
    const data = getWarehouseZonesHomeReducer?.warehouses?.data || {};
    setWarehouseOccuZonesData(data);
  }, [getWarehouseZonesHomeReducer]);

  const handleBarClick = (cardId, event) => {
    const chart = chartRefs.current[cardId]?.current;
    if (!chart) return;

    const elements = chart.getElementsAtEventForMode(
      event.nativeEvent,
      "nearest",
      { intersect: true },
      false,
    );

    if (elements.length === 0) return;

    const index = elements[0].index;
    const card = chartDataList.find((c) => c.type === cardId);
    const warehouseId = card?.currentData?.warehouseIds?.[index];

    if (!warehouseId || card?.isZoneView) return;
    getWarehouseZonesReportHome(warehouseId, jwtToken);

    setSelectedCardId(cardId);
    setSelectedWarehouseId(warehouseId);
  };

  useEffect(() => {
    if (!selectedCardId || !selectedWarehouseId) return;

    const zones = warehouseOccuZonesData[selectedWarehouseId];

    if (!Array.isArray(zones) || zones.length === 0) return;

    const dynamicZoneChart = {
      labels: zones.map((z) => z.label),
      datasets: [
        {
          label: "Filled",
          data: zones.map((z) => z.filled),
          backgroundColor: zones.map((z) => z.colors?.filled?.bg || "#ddd"),
          borderColor: zones.map((z) => z.colors?.filled?.border || "#aaa"),
          borderWidth: 1,
        },
        {
          label: "Empty",
          data: zones.map((z) => z.empty),
          backgroundColor: zones.map((z) => z.colors?.empty?.bg || "#eee"),
          borderColor: zones.map((z) => z.colors?.empty?.border || "#bbb"),
          borderWidth: 1,
        },
      ],
    };

    setChartDataList((prevList) =>
      prevList.map((c) =>
        c.type === selectedCardId
          ? {
              ...c,
              isZoneView: true,
              currentData: dynamicZoneChart,
            }
          : c,
      ),
    );

    setSelectedCardId(null);
    setSelectedWarehouseId(null);
  }, [warehouseOccuZonesData, selectedCardId, selectedWarehouseId]);

  const handleBack = (cardId) => {
    setChartDataList((prevList) =>
      prevList.map((c) =>
        c.type === cardId
          ? { ...c, isZoneView: false, currentData: c.initialData }
          : c,
      ),
    );
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Card sx={{ boxShadow: 3 }}>
        <ReportsBarChart
          color="info"
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span
                style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}
              >
                {warehouseOccupancyTitle}
              </span>
              <IconButton
                style={styles.iconButton}
                onClick={handleOpen}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                aria-label="Home"
              >
                <AspectRatioIcon />
              </IconButton>
            </div>
          }
          chart={chartDataReport}
        />
      </Card>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "90%",
            maxWidth: "none",
            height: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            position: "relative",
          }}
        >
          {warehouseOccupancyTitle}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {chartDataList.map((card) => (
            <Box ml={2} mt={2} key={card.type}>
              <Card sx={{ boxShadow: 3 }}>
                <CardContent>
                  {card.isZoneView && (
                    <MDButton
                      variant="contained"
                      color="secondary"
                      onClick={() => handleBack(card.type)}
                      startIcon={<ArrowBackIcon />}
                      sx={{
                        mb: 2,
                        px: 3,
                        py: 1.5,
                        borderRadius: "12px",
                        background:
                          "linear-gradient(45deg,rgba(110, 113, 241, 1) 30%,rgba(167, 171, 247, 1) 90%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: "0 6px 15px rgba(0,0,0,0.4)",
                        },
                      }}
                    >
                      Back
                    </MDButton>
                  )}

                  <Box sx={{ overflowX: "auto" }}>
                    <MDTypography variant="h6" textTransform="capitalize">
                      {card.isZoneView
                        ? `Expanded Zone Occupancy Status (${card.title})`
                        : card.title}
                    </MDTypography>
                    <Box
                      sx={{
                        minWidth: `${card.currentData.labels.length * 60}px`,
                      }}
                    >
                      <Bar
                        key={
                          card.isZoneView
                            ? `zone-${card.type}`
                            : `warehouse-${card.type}`
                        }
                        ref={chartRefs.current[card.type]}
                        data={card.currentData}
                        onClick={(event) => handleBarClick(card.type, event)}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            datalabels: {
                              anchor: "center",
                              align: "center",
                              offset: 8,
                              clamp: true,
                              formatter: (value) => (value > 0 ? value : ""),
                              font: {
                                size: 12,
                              },
                            },
                          },
                          scales: {
                            x: { stacked: true },
                            y: { stacked: true },
                          },
                          onHover: (event, chartElement) => {
                            event.native.target.style.cursor =
                              chartElement?.length ? "pointer" : "default";
                          },
                        }}
                        height={600}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getWarehouseOccupancyReportHomeReducer:
      state.getWarehouseOccupancyReportHomeReducer,
    getWarehouseOccupancyDataReducer: state.getWarehouseOccupancyDataReducer,
    getWarehouseZonesHomeReducer: state.getWarehouseZonesHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWarehouseOccupancyReportHome: (jwtToken) =>
      dispatch(getWarehouseOccupancyReportHome(jwtToken)),

    getWarehouseOccupancyCardData: (jwtToken) =>
      dispatch(getWarehouseOccupancyCardData(jwtToken)),
    getWarehouseZonesReportHome: (id, jwtToken) =>
      dispatch(getWarehouseZonesReportHome(id, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WarehouseOccupancyHomePageCard);
